export default __webpack_public_path__ + "static/media/schwarzL.c01f0923.jpg";